export enum FlowSyncAccessPolicy {
    READ = "ReadAccess",
    EXPORT_UNEXPORTED_PASSWORD = "ExportUnexportedPassword",
    EXPORT_EXPORTED_PASSWORD = "ExportExportedPassword",
    READ_OVERVIEW = "ReadOverviewAccess",
    ALLOWED_GET_SENSITIVE_FIELDS = "AllowGetSensitiveFields",
    START_MODULE = "StartModuleAccess",
    EDIT_INFORMATION = "EditInformationAccess",
    EDIT_MODULE = "EditModuleAccess",
    AUDIT_LOG_READ = "AuditLogReadAccess",
    ROLE_ASSIGN = "RoleAssign",
    ROLE_ADMIN = "RoleAdmin",
    EDIT_WORD_LISTS = "EditWordLists",
    EDIT_PASSWORD_SETTINGS = "EditPasswordSettings",
    CHANGE_PASSWORDS = "ChangePasswords",
    CLASSROOM_ADMIN_READ = "ClassroomAdminRead",
    CLASSROOM_ADMIN_EDIT = "ClassroomAdminEdit",
    GOOGLE_DEVICE_READ = "GoogleDeviceRead",
    GOOGLE_DEVICE_EDIT = "GoogleDeviceEdit",
    GOOGLE_DEVICE_READ_SENSITIVE = "GoogleDeviceReadSensitive",
    EDIT_APPTOKEN = "EditAppToken",
}

export const getPolicyName = (policy: FlowSyncAccessPolicy) => {
    if (policy === FlowSyncAccessPolicy.READ) {
        return "Läsa";
    }

    if (policy === FlowSyncAccessPolicy.READ_OVERVIEW) {
            return "Läsa översikt";
    }

    if (policy === FlowSyncAccessPolicy.EXPORT_EXPORTED_PASSWORD) {
        return "Administrera lösenord";
    }

    if (policy === FlowSyncAccessPolicy.EXPORT_UNEXPORTED_PASSWORD) {
        return "Exportera lösenord";
    }
    if (policy === FlowSyncAccessPolicy.CHANGE_PASSWORDS) {
        return "Byt lösenord";
    }
}

export const isAuthorized = (authorizedPolicies: FlowSyncAccessPolicy[], policy: FlowSyncAccessPolicy) => {
    return authorizedPolicies.some(p => p === policy);
}